import { AppFunctionComponent } from "../../types"
import React from "react"
import {
  PrimaryHeading,
  SecondaryHeading,
} from "../../components/common/heading.component"
import MiddleContentNewsletter from "../../components/common/middle-content-newsletter.component"
import {
  BackgroundWrapper,
  FullSection,
  FullSectionLandingKickstarter,
  FullSectionLandingKickstarterWrapper,
  SectionArticle,
  SectionLayout,
} from "../../components/common/sections/section.component"
import {
  NewsletterContainer,
  ScrollHandler,
} from "../../components/newsletter/newsletter.component"
import { NewsletterBuilder, NewsletterLayout } from "../../types"
import RichText from "../rich-text/rich-text.resolver"
import { KICKSTARTER_MAILCHIMP_STATUS } from "../../constants/kickstarter"

const NewsletterResolver: AppFunctionComponent<NewsletterBuilder> = ({
  title,
  text,
  disclaimer: { disclaimer },
  mailchimpListId,
  buttonText,
  layout,
  channel,
  tags,
  style,
  successMessage,
}) => {
  if (layout === NewsletterLayout.MiddleContent) {
    return (
      <MiddleContentNewsletter
        buttonText={buttonText}
        disclaimerText={disclaimer}
        mailchimpList={mailchimpListId}
        channel={channel}
      >
        <SecondaryHeading renderAs={"h3"}>{title}</SecondaryHeading>
        {text && <RichText content={text} />}
      </MiddleContentNewsletter>
    )
  }
  if (layout === NewsletterLayout.Kickstarter) {
    return (
      <FullSection layout={SectionLayout.KickstarterNewsletter}>
        <ScrollHandler id={"newsletter"} />
        <SectionArticle>
          <PrimaryHeading renderAs={"div"}>{title}</PrimaryHeading>
          {text && <RichText content={text} />}
          <NewsletterContainer
            buttonText={buttonText}
            disclaimerText={disclaimer}
            mailchimpList={mailchimpListId}
            channel={channel}
            tags={tags}
            status={KICKSTARTER_MAILCHIMP_STATUS}
            successMessage={successMessage}
          />
        </SectionArticle>
      </FullSection>
    )
  }
  if (layout === NewsletterLayout.KickstarterInline) {
    return (
      <FullSectionLandingKickstarterWrapper customStyle={style}>
        <FullSectionLandingKickstarter
          layout={SectionLayout.KickstarterInlineNewsletter}
          customStyle={style}
        >
          <ScrollHandler id={"newsletter"} />
          <SectionArticle>
            <PrimaryHeading renderAs={"div"}>{title}</PrimaryHeading>
            {text && <RichText content={text} />}
            <NewsletterContainer
              buttonText={buttonText}
              disclaimerText={disclaimer}
              mailchimpList={mailchimpListId}
              channel={channel}
              tags={tags}
              status={KICKSTARTER_MAILCHIMP_STATUS}
              successMessage={successMessage}
            />
          </SectionArticle>
        </FullSectionLandingKickstarter>
      </FullSectionLandingKickstarterWrapper>
    )
  }
  return style?.background ? (
    <BackgroundWrapper style={style} layout={SectionLayout.Newsletter}>
      <ScrollHandler id={"newsletter"} />
      <SectionArticle>
        <PrimaryHeading renderAs={"div"}>{title}</PrimaryHeading>
        {text && <RichText content={text} />}
        <NewsletterContainer
          buttonText={buttonText}
          disclaimerText={disclaimer}
          mailchimpList={mailchimpListId}
          channel={channel}
          tags={tags}
          successMessage={successMessage}
        />
      </SectionArticle>
    </BackgroundWrapper>
  ) : (
    <FullSection layout={SectionLayout.Newsletter}>
      <ScrollHandler id={"newsletter"} />
      <SectionArticle>
        <PrimaryHeading renderAs={"div"}>{title}</PrimaryHeading>
        {text && <RichText content={text} />}
        <NewsletterContainer
          buttonText={buttonText}
          disclaimerText={disclaimer}
          mailchimpList={mailchimpListId}
          channel={channel}
          tags={tags}
          successMessage={successMessage}
        />
      </SectionArticle>
    </FullSection>
  )
}

export default NewsletterResolver
